import { useState } from 'react';

import { useAddToast } from '../../../../../../contexts/ToastContext';
import { put } from '../../../../../../redux/api';

const useResendingEmailTokenIds = (organizationId: number) => {
  const addToast = useAddToast();
  const [tokenIds, setTokenIds] = useState<number[]>([]);
  const resendEmailToken = async (tokenId: number) => {
    try {
      setTokenIds((previousTokenIds) => [...previousTokenIds, tokenId]);
      await put(`/api/organizations/${organizationId}/resend-domain-verification-email/${tokenId}`, {});
      addToast({ type: 'success', content: 'Email has been sent' });
    } catch (error: unknown) {
      addToast({ type: 'error', content: 'Failed to resend email token' });
    } finally {
      setTokenIds((previousTokenIds) => previousTokenIds.filter((previousTokenId) => previousTokenId !== tokenId));
    }
  };

  return {
    tokenIds,
    resendEmailToken,
  };
};

export default useResendingEmailTokenIds;
